<!-- 流式组件包装组件，提供宽度设定和上下间距 -->
<template>
  <div
    :class="[
      'flowComponentContainer',
      { hasGap: hasGap, fullWidth: fullWidth }
    ]"
  >
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    hasGap: {
      type: Boolean,
      default: true
    },
    fullWidth: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="less" scoped>
.flowComponentContainer {
  width: 702px;
  margin: 0 auto;

  &.fullWidth {
    width: 750px;
  }

  &.hasGap {
    padding: 24px 0;
  }

  &:first-child {
    padding-top: 0;
  }

  &:only-child {
    padding-bottom: 0;
  }
}
</style>
